/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { DebounceClickDirective } from '../debounce-click.directive';
import { TooltipModule } from 'primeng/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { AttachmentSaveLocationType, AttachmentVO, BaseAttachmentDTO } from '@well/attachment/domain';
import { Subject } from 'rxjs';
import { CrmFileStorageService, DeliveryFileStorageService } from '@well/resource-services';

@Component({
  selector: 'well-attachment-list-item',
  standalone: true,
  imports: [CommonModule, ButtonModule, DebounceClickDirective, TooltipModule, TranslateModule],
  templateUrl: './attachment-list-item.component.html',
  styleUrl: './attachment-list-item.component.scss',
  providers: [CrmFileStorageService, DeliveryFileStorageService]
})
export class AttachmentListItemComponent {
  @Input() attachment: BaseAttachmentDTO | AttachmentVO | undefined = undefined;
  @Input() canDelete = false;
  @Input() canSync = false;

  @Output() delete: Subject<string> = new Subject<string>();
  @Output() sync = new EventEmitter<string>();

  fileNameLength = 40;

  constructor(private crmFileStorageService: CrmFileStorageService,
              private deliveryFileStorageService: DeliveryFileStorageService) {}

  download(id: string | undefined) {
    if(!id) {
      throw new Error("Attachment has no file store attachment uuid!");
    }

    if(this.attachment?.attachmentSaveLocation === AttachmentSaveLocationType.DELIVERY) {
      this.deliveryFileStorageService.downloadFileById(id);
    } else {
      this.crmFileStorageService.downloadFileById(id);
    }
  }

  onDelete(uuid: string) {
    if(!uuid) {
      throw new Error("Attachment has no file store attachment uuid!");
    }

    this.delete.next(uuid);
  }

  onSync(uuid: string | undefined) {
    if(!uuid) {
      throw new Error("Attachment has no uuid!");
    }

    this.sync.emit(uuid);
  }
}
